import React from "react"

import { CurrentPage, NotFoundErrorPage, connect } from "scrivito"
import { ErrorPage } from "shared/ui/error-page/ErrorPage"

function PageWrapper() {
  return (
    <>
      <CurrentPage />
      <NotFoundErrorPage>
        <ErrorPage />
      </NotFoundErrorPage>
    </>
  )
}

export default React.memo(connect(() => <PageWrapper />))
